<template>
    <v-snackbar v-model="showPopup" :color="bgColor" top>
      {{message}}
      <v-btn dark flat icon @click="showPopup = false">
        <v-icon>cancel</v-icon>
      </v-btn>
    </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    showPopup: false
  }),
  computed: {
    bgColor() {
      if (this.isError) {
        return "error"
      }
      if (this.isWarning) {
        return "tertiary"
      }
      return "success"
    }
  },
  props: {
    message: String,
    timestamp: Date,
    isError: Boolean,
    isWarning: Boolean
  },
  watch: {
    message: function () {
      this.showPopup = true
    },
    timestamp: function() {
      this.showPopup = true
    }
  }
}
</script>
